import script from "./DocumentoEntradaAcoesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoEntradaAcoesGrid.vue?vue&type=script&setup=true&lang=js"

import "./DocumentoEntradaAcoesGrid.vue?vue&type=style&index=0&id=20250206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20250206"]])

export default __exports__